var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvalidIconGraphics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.143 23.6941C119.672 24.2112 120 24.9255 120 25.7141C120 26.5026 119.672 27.2169 119.143 27.7341C118.613 28.2512 117.881 28.5712 117.073 28.5712C115.458 28.5712 114.146 27.2912 114.146 25.7141C114.146 24.9255 114.474 24.2112 115.004 23.6941C115.534 23.1769 116.266 22.8569 117.073 22.8569C117.881 22.8569 118.613 23.1769 119.143 23.6941Z",
    fill: "#94D4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.435 109.409C107.965 109.926 108.293 110.641 108.293 111.429C108.293 112.217 107.965 112.932 107.435 113.449C106.905 113.966 106.173 114.286 105.366 114.286C103.75 114.286 102.439 113.006 102.439 111.429C102.439 110.64 102.767 109.926 103.297 109.409C103.827 108.892 104.558 108.572 105.366 108.572C106.173 108.572 106.905 108.892 107.435 109.409Z",
    fill: "#94D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.976 0C105.018 0 108.293 3.19714 108.293 7.14286C108.293 11.0886 105.018 14.2857 100.976 14.2857C96.9338 14.2857 93.6587 11.0886 93.6587 7.14286C93.6587 3.19714 96.9338 0 100.976 0Z",
    fill: "#F88F19"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4147 111.429C85.8381 111.429 87.8049 113.349 87.8049 115.714C87.8049 118.08 85.8381 120 83.4147 120C80.9912 120 79.0244 118.08 79.0244 115.714C79.0244 113.349 80.991 111.429 83.4147 111.429Z",
    fill: "#F88F19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.167 6.81126C78.6968 7.32841 79.0246 8.04269 79.0246 8.83126C79.0246 9.61984 78.6968 10.3341 78.167 10.8513C77.6369 11.3684 76.9052 11.6884 76.0977 11.6884C74.4821 11.6884 73.1709 10.4084 73.1709 8.83126C73.1709 8.04269 73.4987 7.32841 74.0285 6.81126C74.5585 6.29412 75.2902 5.97412 76.0977 5.97412C76.9052 5.97412 77.6369 6.29412 78.167 6.81126Z",
    fill: "#94D4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5327 115.123C64.0625 115.64 64.3903 116.355 64.3903 117.143C64.3903 117.931 64.0625 118.646 63.5327 119.163C63.0027 119.68 62.271 120 61.4635 120C59.8478 120 58.5366 118.72 58.5366 117.143C58.5366 116.354 58.8644 115.64 59.3942 115.123C59.9242 114.606 60.6559 114.286 61.4635 114.286C62.271 114.286 63.0027 114.606 63.5327 115.123Z",
    fill: "#94D4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0446 3.69408C43.5747 4.21122 43.9025 4.92551 43.9025 5.71408C43.9025 6.50265 43.5747 7.21693 43.0446 7.73408C42.5149 8.25122 41.7832 8.57122 40.9757 8.57122C39.3598 8.57122 38.0488 7.29122 38.0488 5.71408C38.0488 4.92551 38.3766 4.21122 38.9064 3.69408C39.4364 3.17693 40.1681 2.85693 40.9757 2.85693C41.7832 2.85693 42.5149 3.17693 43.0446 3.69408Z",
    fill: "#94D4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6339 5.71436C17.8681 5.71436 20.4876 8.2715 20.4876 11.4286C20.4876 14.5858 17.8681 17.1429 14.6339 17.1429C11.3998 17.1429 8.78027 14.5858 8.78027 11.4286C8.78027 8.2715 11.3998 5.71436 14.6339 5.71436Z",
    fill: "#F88F19"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99581 106.551C5.52585 107.069 5.85366 107.783 5.85366 108.571C5.85366 109.36 5.52585 110.074 4.99581 110.592C4.46605 111.109 3.73434 111.429 2.92683 111.429C1.31093 111.429 0 110.149 0 108.571C0 107.783 0.327805 107.069 0.857561 106.551C1.38761 106.034 2.11932 105.714 2.92683 105.714C3.73434 105.714 4.46605 106.034 4.99581 106.551Z",
    fill: "#94D4FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3335 79.6667V49H86.6668V79.6667C86.6668 81.1333 85.4668 82.3333 84.0002 82.3333H36.0002C34.5335 82.3333 33.3335 81.1333 33.3335 79.6667Z",
    fill: "#C1E8FB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6668 42.3332V48.9998H33.3335V42.3332C33.3335 40.8665 34.5335 39.6665 36.0002 39.6665H84.0002C85.4668 39.6665 86.6668 40.8665 86.6668 42.3332Z",
    fill: "#2760AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38 46.3335C39.1046 46.3335 40 45.4381 40 44.3335C40 43.2289 39.1046 42.3335 38 42.3335C36.8954 42.3335 36 43.2289 36 44.3335C36 45.4381 36.8954 46.3335 38 46.3335Z",
    fill: "url(#paint0_linear_2091_28805)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6665 46.3335C45.7711 46.3335 46.6665 45.4381 46.6665 44.3335C46.6665 43.2289 45.7711 42.3335 44.6665 42.3335C43.5619 42.3335 42.6665 43.2289 42.6665 44.3335C42.6665 45.4381 43.5619 46.3335 44.6665 46.3335Z",
    fill: "url(#paint1_linear_2091_28805)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3335 46.3335C52.4381 46.3335 53.3335 45.4381 53.3335 44.3335C53.3335 43.2289 52.4381 42.3335 51.3335 42.3335C50.2289 42.3335 49.3335 43.2289 49.3335 44.3335C49.3335 45.4381 50.2289 46.3335 51.3335 46.3335Z",
    fill: "url(#paint2_linear_2091_28805)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6379 92.2758C85.6176 92.2758 91.2758 86.6176 91.2758 79.6379C91.2758 72.6582 85.6176 67 78.6379 67C71.6582 67 66 72.6582 66 79.6379C66 86.6176 71.6582 92.2758 78.6379 92.2758Z",
    fill: "url(#paint3_linear_2091_28805)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0613 74.3297L83.946 75.2144C84.1987 75.4671 84.1987 75.8463 83.946 76.099L74.973 85.0719C74.7203 85.3247 74.3411 85.3247 74.0884 85.0719L73.2037 84.1873C72.951 83.9345 72.951 83.5554 73.2037 83.3026L82.1766 74.3297C82.4294 74.0769 82.8085 74.0769 83.0613 74.3297Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.946 84.0613L83.0613 84.946C82.8085 85.1987 82.4294 85.1987 82.1766 84.946L73.2037 75.973C72.951 75.7203 72.951 75.3411 73.2037 75.0884L74.0884 74.2037C74.3411 73.951 74.7203 73.951 74.973 74.2037L83.946 83.1766C84.1987 83.4294 84.1987 83.8085 83.946 84.0613Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2091_28805",
    x1: 37.0013,
    y1: 42.8882,
    x2: 38.7093,
    y2: 45.3588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49BEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2091_28805",
    x1: 43.6678,
    y1: 42.8882,
    x2: 45.3758,
    y2: 45.3588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49BEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2091_28805",
    x1: 50.3348,
    y1: 42.8882,
    x2: 52.0428,
    y2: 45.3588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49BEF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2091_28805",
    x1: 66,
    y1: 79.6379,
    x2: 91.2758,
    y2: 79.6379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#EE3D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E52030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidIconGraphics);
export default __webpack_public_path__ + "static/media/invalid-icon-graphics.283499a34deea87b864577c892181e5b.svg";
export { ForwardRef as ReactComponent };